// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__3HYwx","consentsList":"PatientConsents_consentsList__BVamR","consentsListEmpty":"PatientConsents_consentsListEmpty__Hu0sl"};